import React, { useEffect, useState } from 'react';
import { api } from '../../../app/Api/ApiSlice';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../../../components/Loader';
import InfiniteScroll from 'react-infinite-scroll-component';
import ReceivedStoreParentReqCard from '../../../components/ReceivedStoreParentReqCard';

const ReceivedParentStoresRequests = () => {
    const [stores, setStores] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const { name } = useParams();

    useEffect(() => {
        const getStores = async () => {
            try {
                setIsLoading(true);
                const response = await api.get(`/stores/${name}/manage/parent/requests/received`, {
                    params: { page },
                });

                console.log("received_parent_requests:",response)

                const newBranches = response.data;

                setStores((prev) =>
                    page === 1 ? newBranches : [...prev, ...newBranches]
                );

                // If fewer items are returned than expected, assume no more pages
                if (newBranches.length === 0 || newBranches.length < 10) {
                    setHasMore(false);
                }
            } catch (error) {
                toast.error(error?.response?.data?.message || 'Something went wrong');
                setHasMore(false);
            } finally {
                setIsLoading(false);
            }
        };

        getStores();
    }, [page, name]);

    const handleRefresh = async () => {
        setPage(1);
        setHasMore(true);
    };

    return (
        <div>
            <h2 className='page-header-title'>Requesting to be parent</h2>
            <InfiniteScroll
                dataLength={stores?.length}
                next={() => setPage((prev) => prev + 1)}
                hasMore={hasMore}
                refreshFunction={handleRefresh}
                pullDownToRefresh
                pullDownToRefreshThreshold={50}
                pullDownToRefreshContent={
                    <h4 style={{ textAlign: 'center' }}>↓ Pull down to refresh</h4>
                }
                releaseToRefreshContent={
                    <h4 style={{ textAlign: 'center' }}>↑ Release to refresh</h4>
                }
                loader={<Loader />}
            >
                {stores?.length > 0 ? (
                    stores.map((b) => (
                        <div className="add-branch-container" key={b.id}>
                            <ReceivedStoreParentReqCard b={b} />
                        </div>
                    ))
                ) : (
                    !isLoading && <p className='not-found-msg'>No business has been requested to be branch</p>
                )}
            </InfiniteScroll>
        </div>
    );
};

export default ReceivedParentStoresRequests;
